import { StyledAlert } from "App/global-style";
import { RadioButton } from "Components/Form/RadioButton";
import { useTexts } from "Components/TextContext";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { HuseierneMembershipStatus } from "../partnerFormValuesInterfaces";
import { LinkToHuseierne } from "./LinkToHuseierne";

interface Props {
  formProps: FormikProps<any>;
}

export const HuseierneMembershipStatusFormElements = ({
  formProps,
}: Props): React.ReactElement => {
  const { getText } = useTexts();
  return (
    <>
      <RadioButton
        name="huseierneMembershipStatus"
        id="huseierneMembershipStatus"
        label={getText("partnerhuseierne.label.huseiernemembershipstatus")}
        options={[
          {
            label: getText(
              "partnerhuseierne.option.huseiernemembership_has_membership",
            ),
            value: HuseierneMembershipStatus.HAS_HUSEIERNE_MEMBERSHIP,
            id: HuseierneMembershipStatus.HAS_HUSEIERNE_MEMBERSHIP,
          },
          {
            label: getText(
              "partnerhuseierne.option.huseiernemembership_has_no_membership",
            ),
            value: HuseierneMembershipStatus.WANTS_HUSEIERNE_MEMBERSHIP,
            id: HuseierneMembershipStatus.WANTS_HUSEIERNE_MEMBERSHIP,
          },
        ]}
        direction="vertical"
        error={getError("huseierneMembershipStatus", formProps)}
      />
      {formProps.values.huseierneMembershipStatus ===
        HuseierneMembershipStatus.WANTS_HUSEIERNE_MEMBERSHIP && (
        <StyledAlert
          type="info"
          title={getText(
            "partnerhuseierne.alerttitle.huseiernemembershipstatus",
          )}
          fluid
        >
          <p>
            {getText(
              "partnerhuseierne.alertdescription.huseiernemembershipstatus",
            )}
          </p>
          <LinkToHuseierne />
        </StyledAlert>
      )}
    </>
  );
};
